const Russian = () => (
   <svg fill='none' height='24' viewBox='0 0 14 14' width='24'>
      <mask
         height='14'
         id='mask0'
         mask-type='alpha'
         maskUnits='userSpaceOnUse'
         width='14'
         x='0'
         y='0'
      >
         <rect
            fill='#C4C4C4'
            height='13.5'
            rx='6.75'
            width='13.5'
            x='0.25'
            y='0.25'
         />
      </mask>
      <g mask='url(#mask0)'>
         <mask
            height='18'
            id='mask1'
            mask-type='alpha'
            maskUnits='userSpaceOnUse'
            width='22'
            x='-4'
            y='-3'
         >
            <rect x='-4' y='-2.05005' width='22' height='16.5' fill='white' />
         </mask>
         <g mask='url(#mask1)'>
            <mask
               height='18'
               id='mask2'
               mask-type='alpha'
               maskUnits='userSpaceOnUse'
               width='22'
               x='-4'
               y='-3'
            >
               <path
                  clipRule='evenodd'
                  d='M-4 -2.05005V14.45H18V-2.05005H-4Z'
                  fill='white'
                  fillRule='evenodd'
               />
            </mask>
            <g mask='url(#mask2)'>
               <rect
                  fill='#5254F1'
                  height='5.5'
                  width='22'
                  x='-4'
                  y='3.44995'
               />
               <path
                  clipRule='evenodd'
                  d='M-4 -2.05005V3.44995H18V-2.05005H-4Z'
                  fill='#EBF1F5'
                  fillRule='evenodd'
               />
               <path
                  clipRule='evenodd'
                  d='M-4 8.94995V14.45H18V8.94995H-4Z'
                  fill='#C51918'
                  fillRule='evenodd'
               />
            </g>
         </g>
      </g>
   </svg>
);
export default Russian;
